import {
  UPDATE_FIRST_LOGIN_FAILURE,
  UPDATE_FIRST_LOGIN_REQUEST,
  UPDATE_FIRST_LOGIN_SUCCESS,
} from "../../../modules/constants";

const initialState = {
  isFirstLogin: false,
  isLoadingFirstLogin: false,
  error: null,
};

export const updateFirstLoginRequestHandler = (state, action) => {
  return {
    ...state,
    isLoadingFirstLogin: true,
    error: null,
  };
};

export const updateFirstLoginSuccessHandler = (state, action) => {
  return {
    ...state,
    isLoadingFirstLogin: false,
    isFirstLogin: false,
  };
};

export const updateFirstLoginFailureHandler = (state, action) => {
  return {
    ...state,
    isLoadingFirstLogin: false,
    error: action.error,
  };
};

const ACTION_HANDLERS = {
  [UPDATE_FIRST_LOGIN_REQUEST]: updateFirstLoginRequestHandler,
  [UPDATE_FIRST_LOGIN_SUCCESS]: updateFirstLoginSuccessHandler,
  [UPDATE_FIRST_LOGIN_FAILURE]: updateFirstLoginFailureHandler,
};

export default function onboardingReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
